import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Loading from '../../components/Loading';

const Login = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  if (!isAuthenticated) {
    loginWithRedirect();
    return <Loading heading="Loading" text="Redirecting you to login screen" />;
  }

  return <Loading heading="Loading" text="Please wait..." />;
};

export default Login;
